<template>
  <!--  <a-skeleton :loading="loading" active :paragraph="{width:'100%',rows:5}" :title="false">-->
  <div>
    <div class="inputDiv">

      <div class="opationRow">
        <slot>
          <pt-search v-model="searchText" :placeholder="searchPlaceholder" @searchEvent="searchEvent"></pt-search>
        </slot>
      </div>
      <div class="add-btn">
        <a-button type="primary" shape="circle" icon="plus" @click.stop="clickEvent"></a-button>
      </div>
    </div>
    <a-table @change="change" :customRow="customRowSet" :rowSelection="rowSelection" :rowKey="rowKey" :loading="loading"  :dataSource="dataSource" :pagination="pagination" :scroll="scroll"
    :columns="columns">
      <slot name="columns"></slot>
    </a-table>
  </div>

  <!--  </a-skeleton>-->
</template>

<script>

  export default {
    name: 'index',
    props:{
      searchPlaceholder:{
        type:String,
        default:'请输入关键字, 按回车键查询',
      },
      dataSource:{
        type:Array,
        default:()=>{return []}
      },
      total:{
        default:-1,
      },
      rowKey:{
        type:String,
        default:'id'
      },
      loading:{
        type:Boolean,
        default: true,
      },
      rowSelection:{
        type:Object,
        default:null
      },
      scroll:{
        type:Object,
        default:()=>{return null}
      },
      columns:{
        type:Array,
        default:()=>{return null}
      }
    },
    data(){
      return {
        searchText:'',
        pagination:{
          pageSize:20,
          total:-1,
          size:'small',
          hideOnSinglePage:true,
          showTotal:(total)=>{
            return `共${total}条`
          }
        }
      }
    },
    watch:{
      total(newValue){
        this.pagination.total = newValue
      },
    },
    methods:{
      clickEvent(){
        this.$emit('add')
      },
      searchEvent(){
        this.$emit('search',this.searchText)
      },
      change(pagination, filters, sorter){
        console.log(pagination)
        console.log(filters)
        console.log(sorter)
        this.$emit('tableChange',pagination, filters, sorter)
      },
      customRowSet(record){
        let _this = this;
        return {
          on:{
            click:()=>{
              _this.$emit('rowClick',record)
            }
          }
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .inputDiv{
    margin-bottom: 37px;
    position: relative;
    .opationRow{
      display: flex;
    }
  }
  .add-btn{
    position: absolute;
    right: 0;
    top: 46%;
    button{
      box-shadow: 0 7px 9px 0 rgba(59,46,38,0.42);
    }
  }

</style>